import { Box, Button, Grommet, Heading, Text, Image } from "grommet";
import * as React from "react";
import { useUser } from "../utils/AccountStore";
import StyledModal from "./StyledModel";
import { useDarkMode } from "../components/DarkModeSwitch";
import { FaCodepen } from "react-icons/fa6";
import { FcSignature } from "react-icons/fc";
import Signature from "@uiw/react-signature/canvas";

export interface SignatureOptionValue {
    image: string;
    user: string;
    userName: string;
    timestamp: number;
}

const SignatureOption = ({ changed, value, disabled }) => {
    const { user } = useUser();
    const [signature, setSignature] = React.useState({} as SignatureOptionValue);

    React.useEffect(() => {
        setSignature(JSON.parse(value || "{}"));
    }, [value]);

    // React.useEffect(() => {
    //     if (signature) {
    //         changed(JSON.stringify(signature));
    //     }
    // }, []);

    const [showModal, setShowModal] = React.useState(false);

    const signRef = React.useRef<any>();

    const doSign = () => {
        if (signRef.current) {
            let image = signRef.current.canvas.toDataURL("image/png");
            let signature = { image, user: user.id, userName: user.displayName, timestamp: +new Date() };
            setSignature(signature);
            changed(JSON.stringify(signature));
            setShowModal(false);
        }
    };

    const clearSign = () => {
        changed(null);
        setShowModal(false);
    };

    const [isDarkMode] = useDarkMode();

    return (
        <Box margin="small">
            <Box
                direction="row"
                justify="between"
                pad="small"
                gap="small"
                width={{ max: "200px" }}
                border={{ side: "bottom", color: "background-back", size: "small" }}
                hoverIndicator={!disabled ? "background-back" : ""}
                onClick={() => !disabled && setShowModal(true)}
            >
                {signature.image && <Image src={signature.image} style={{ maxWidth: "200px", filter: isDarkMode ? "invert(1)" : "" }}></Image>}
                {!signature.image && <Text>Click to Sign</Text>}
                <FcSignature size="24px" />
            </Box>
            <Text color="background-front">{user.displayName}</Text>
            {!!signature.timestamp && (
                <Text color="background-front" size="xsmall">
                    {new Date(signature.timestamp).toLocaleString()}
                </Text>
            )}
            <StyledModal isOpen={showModal} setIsOpen={() => setShowModal(false)}>
                <Box gap="small">
                    <Box border={{ side: "all", color: "background-back", size: "small" }}>
                        <Box style={{ filter: isDarkMode ? "invert(1)" : "" }}>
                            <Signature ref={signRef} />
                        </Box>
                    </Box>
                    <Box direction="row" justify="end" gap="small">
                        {signature.image && <Button label="Remove Signature" color={"status-critical"} onClick={clearSign}></Button>}
                        <Button label="Confirm and Sign" onClick={doSign}></Button>
                    </Box>
                </Box>
            </StyledModal>
        </Box>
    );
};

export default SignatureOption;
